export default __webpack_public_path__ + "static/media/spark_40.7a5061ee.png";